import React from 'react';
import { Tooltip } from '@mui/material';

const TemplateDashboardAddTabTrigger = ({
    title,
    addTriggerRef,
    onOpen,
}) => (
    <Tooltip title={title}>
        <div style={{ position: 'relative' }}>
            <span
                className="details-control-btn add-dashboard-trigger"
                style={{
                    border: '1px dashed var(--add-tab-border)',
                    marginBottom: '4px',
                    fontSize: 'calc(var(--large) * var(--font-size-multiplier))',
                }}
                onClick={(e) => {
                    e.stopPropagation();
                    addTriggerRef.current = e.currentTarget;
                    onOpen(e.currentTarget);
                }}
            >
                +
            </span>
        </div>
    </Tooltip>
);

export default TemplateDashboardAddTabTrigger;
